<ng-container *ngIf="item">
  <i *ngIf="!(item|isBookmark)" class="lvi-thel-coeur-vide" (click)="onBookmarkClick()"></i>
  <i *ngIf="(item|isBookmark)" class="lvi-thel-coeur-plein" (click)="onBookmarkClick()"></i>
</ng-container>

